// import React from 'react';
import React, { useCallback, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';
// import useForm from 'react-hook-form';
import classNames from 'classnames';
import { FORGOT_PASSWORD } from '../../Redux/Actions/ActionType';

import { UpdatePassword, ForgotPassword } from '../../Redux/Actions/UserAction';
import { useTranslation } from 'react-i18next';

const ResetPassword = () => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'all' });
  const [isActive, setIsActive] = useState(false);
  const [user, setUser] = useState({
    username: '',
    otp: '',
    newPassword: '',
  });
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();

  function handleChange(e) {
    const { name, value } = e.target;
    setUser((user) => ({ ...user, [name]: value }));
  }

  function RPasswordSubmit(e) {
    dispatch(UpdatePassword(user));
    console.log(user);
  }

  const GetOtp = async (data) => {
    try {
      axios

        .post(
          'https://api.carsavenue.com/api/user/forgotPassword',
          data
        )

        .then((res) => {
          console.log('heeee<<<<', res);
          dispatch({
            type: FORGOT_PASSWORD,
            payload: res.data,
          });

          console.log('heeee<<<<', res);
          setIsActive(res.data.response.isActive);
        })
        .catch((err) => {
          console.log(err);
          const errorMessage = err?.response?.data?.response?.message || err?.response?.data?.message || '';
          let title = t('User not found. Please check your username and try again.');
          if (errorMessage) {
            title = errorMessage;
          }
          Swal.fire({
            title: title,
            icon: 'error',
            imageUrl: './assets/images/favicon/android-chrome-192x192.png',
            imageHeight: 100,
            confirmButtonColor: '#3ab1f7',
            confirmButtonText: 'Ok',
          });
        });
    } catch (err) {
      // Swal.fire('Incorrect Credentials', '', 'error');
    }
  };

  const submituserData = React.useCallback(() => {
    console.log('this is username', user.username);

    if (user.username && user.username !== '')
      GetOtp({ username: user.username });
  }, [user]);

  //  useEffect(() => {

  //         if (user.username && user.username !== '') GetOtp({ username: user.username});
  //         // if (home === undefined) fetchProductDetail({ packID: packID });
  //     }, []);

  let home = useSelector((state) => state.home);
  console.log('this is the otp data', home);
  const userotpData = home.ForgotPasswordList;
  if (userotpData !== undefined) {
    console.log('this is user otp  data', userotpData.response.otp);
    // prompt('your otp is ',userotpData.response.otp)
  }

  const resendOtp = () => {
    setIsActive(false);
  };

  return (
    <div class="login-reg-area">
      <div class="container">
        <div class="login-reg-wrap">
          <h3 class="mb-5">Change Password</h3>

          <form onSubmit={handleSubmit(submituserData)}>
            {isActive !== true ? (
              <div>
                <div class="form-group">
                  <label for="reg-fn" class="sr-only">
                    user name
                  </label>
                  <input
                    {...register('username', {
                      required: 'this field is requerd',
                      minLength: {
                        value: 6,
                        message: 'username should be minimum  6 character',
                      },
                      pattern: {
                        value: /^[a-zA-Z0-9]{6,}$/,
                        message: t(
                          'username should only have letters and numbers, minimum 6 characters'
                        ),
                      },
                    })}
                    name="username"
                    type="text"
                    value={user.username}
                    onChange={handleChange}
                    className={classNames('form-control', {
                      'is-invalid': errors.username,
                    })}
                    id="reg-fn"
                    placeholder=" Enter username"
                  />
                  {errors.username && (
                    <p className="invalid-feedback">
                      {errors.username.message}
                    </p>
                  )}
                </div>

                <button
                  class="btn btn-warning btn-block"
                  type="submit"
                  onSubmit={submituserData}
                  // className='btn btn-primary btn-md btn-block waves-effect waves-light text-center m-b-20'

                  // role='button'
                >
                  {/* {loading ? 'Loading ..' : '	REGISTER'} */}
                  Get Otp
                </button>
              </div>
            ) : null}
          </form>
          <form onSubmit={handleSubmit(RPasswordSubmit)}>
            {isActive === true ? (
              <div>
                {' '}
                <div class="form-group">
                  <p>{t('An OTP has been sent to your registered phone number')}</p>
                  <label for="reg-fn" class="sr-only">
                    {t('Enter OTP')}
                  </label>
                  <input
                    {...register('otp', {
                      required: t('This field is required'),
                      minLength: {
                        value: 4,
                        message: t('OTP must be 4 digits'),
                      },
                      pattern: {
                        value: /^\d{4}$/,
                        message: t('OTP must be exactly 4 digits'),
                      },
                    })}
                    name="otp"
                    type="text"
                    inputMode="numeric"
                    maxLength="4"
                    value={user.otp}
                    onChange={handleChange}
                    className={classNames('form-control', {
                      'is-invalid': errors.otp,
                    })}
                    id="reg-fn"
                    placeholder={t('Enter OTP')}
                  />
                  {errors.otp && (
                    <p className="invalid-feedback">{errors.otp.message}</p>
                  )}
                </div>
                {/* <div class='form-group'>
							<label for='reg-ln' class='sr-only'>
								Last name
							</label>
							<input
								{...register('lastName', {
									required: 'this field is requerd',
									minLength: {
										// message: 'plese enter full name 7'
									},
								})}
								name='lastName'
								type='text'
								value={user.lastName}
								onChange={handleChange}
								className={classNames('form-control', {
									'is-invalid': errors.lastName,
								})}
								id='reg-ln'
								placeholder='Last name'
							/>
							{errors.lastName && (
								<p className='invalid-feedback'>{errors.lastName.message}</p>
							)}
						</div> */}
                <div class="form-group" style={{ position: 'relative' }}>
                  <label for="reg-password" class="sr-only">
                    Password
                  </label>
                  <input
                    {...register('newPassword', {
                      required: t('This field is required'),
                      minLength: {
                        value: 8,
                        message: t('Password must have at least 8 characters'),
                      },
                      pattern: {
                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/,
                        message: t('Password must include uppercase, lowercase, number, and special character'),
                      },
                    })}
                    name="newPassword"
                    type={showPassword ? 'text' : 'password'}
                    value={user.newPassword}
                    onChange={handleChange}
                    className={classNames('form-control', {
                      'is-invalid': errors.newPassword,
                    })}
                    id="reg-password"
                    placeholder={t('Enter New Password')}
                    style={{ paddingRight: '42px' }}
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute',
                      right: '14px',
                      top: '12px',
                      cursor: 'pointer',
                      color: '#888',
                      zIndex: 5,
                    }}
                  >
                    <i
                      className={showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'}
                    ></i>
                  </span>
                  {errors.newPassword && (
                    <p className="invalid-feedback">
                      {errors.newPassword.message}
                    </p>
                  )}
                </div>
                <button
                  class="btn btn-warning btn-block"
                  type="submit"
                  onSubmit={handleSubmit(RPasswordSubmit)}
                  // className='btn btn-primary btn-md btn-block waves-effect waves-light text-center m-b-20'

                  // role='button'
                >
                  {/* {loading ? 'Loading ..' : '	REGISTER'} */}
                  Save Change
                </button>
                <div class="mt-2 ">
                  {' '}
                  <Link
                    style={{ textDecoration: 'underline' }}
                    onClick={resendOtp}
                  >
                    resend otp
                  </Link>
                </div>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
